
.dimensionInput {
  min-width: 5rem;
}
